// MsalAuthHandler.js
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { EventType } from "@azure/msal-browser";
import { useNavigate } from "react-router-dom";

const MsalAuthHandler = ({ setLoading }) => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("msalLoginInProgress") === "true") {
      setLoading(true);
    }

    const callbackId = instance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_START) {
        setLoading(true);
      }

      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const account = event.payload.account;
        if (account) {
          instance.setActiveAccount(account);
        }

        const postLoginUrl = sessionStorage.getItem("postLoginUrl") || "/";
        sessionStorage.removeItem("postLoginUrl");
        sessionStorage.removeItem("msalLoginInProgress");

        navigate(postLoginUrl, { replace: true });
        setLoading(false);
      }

      if (event.eventType === EventType.LOGIN_FAILURE) {
        sessionStorage.removeItem("msalLoginInProgress");
        setLoading(false);
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance, navigate, setLoading]);

  return null;
};

export default MsalAuthHandler;
